// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/CcHUB_Pattern_1.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  overflow-x: hidden;
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
}

:root {
  --red: #d22310;
  --navy: #1a2744;
  --yellow: #febe14;
  --white: #ffffff;
  --black: #000000;
  --offWhite: #fff5f4;
  --green: #bad530;
  --purple: #7c68ee;
  --deep-blue: #275ac3;
  --faded-orange: #fed6a3;
}

body {
  margin: 0;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family:
    source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

/* HERO SECTION */

#hero-section {
  position: relative;
  background-color: var(--red);
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
}

.hero-patterns-left,
.hero-patterns-right {
  margin: 4vh 0;
  position: absolute;
  top: 50%;
  height: auto;
  width: min(34vw, 520px);
  max-width: 520px;
  z-index: 0;
  pointer-events: none;
  height: 100%;
  z-index: 3;
}

.hero-patterns-left {
  left: -12%;
  transform: translateY(-50%) scaleX(-1);
  transform-origin: center center;
}

.hero-patterns-right {
  right: -12%;
  transform: translateY(-50%);
  transform-origin: center center;
}

.hero-header {
  position: relative;
  z-index: 1;
  display: flex;
  flex: 1 1;
  min-width: 0;
  width: 90%;
  margin-top: 4vh;
  justify-content: space-between;
  align-items: center;
}
.hero-header img {
  height: 60px;
}

.hero-body {
  position: relative;
  z-index: 3;
  flex: 7 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10vh 20px;
  width: 80%;
  max-width: 1200px;
}

.hero-body p {
  text-align: center;
  color: var(--white);
  font-size: clamp(18px, 4vw, 30px);
  margin: 20px 0;
}

#hero-mini-title {
  font-weight: 1000;
}
.hero-body h1 {
  text-align: center;
  color: var(--white);
  font-size: clamp(48px, 10vw, 120px);
  line-height: 1;
}
.orange-highlight {
  color: var(--faded-orange);
}

.hero-transition {
  background-color: var(--red);
  position: relative;
  width: 100%;
  height: 250px;
  clip-path: ellipse(100% 100% at 50% 0%);
  margin-top: -125px;
  z-index: -1;
  pointer-events: none;
  transition: 0.2s;
}
@media (min-width: 901px) {
  .hero-header button {
    background-color: var(--yellow);
    border: none;
    color: var(--white);
    width: 223px;
    height: 54px;
    font-size: 2vh;
    font-weight: 800;
    border-radius: 10px;
    transition: transform 0.2s;
  }
  .hero-header button:hover {
    transform: scale(1.05);
  }

  #mobile-download-button {
    display: none;
  }
}
@media (max-width: 900px) {
  .hero-patterns-left {
    left: -30%;
  }
  .hero-patterns-right {
    right: -30%;
  }
  #mobile-download-button {
    background-color: var(--yellow);
    border: none;
    color: var(--white);
    width: 223px;
    height: 54px;
    font-size: 2vh;
    font-weight: 800;
    border-radius: 10px;
    transition: transform 0.2s;
  }
  #mobile-download-button:hover {
    transform: scale(1.05);
  }
  .hero-header button {
    display: none;
  }
}

/* INNOVATION SECTION */
.innovation-section {
  padding: 15vh 0 10vh 0;
  z-index: 3;
  overflow: hidden;
  display: flex;
  justify-self: center;
  flex-direction: row;
  width: 80%;
  gap: 40px;
  position: relative;
}
.right-panel {
  flex: 1 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.right-panel h2 {
  font-size: 40px;
  padding-bottom: 4vh;
  line-height: 5vh;
  padding: 0 3vh;
}
.left-panel {
  flex: 1 1;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: visible;
}

.left-panel img {
  position: relative;
  width: 100%;
  max-width: 620px;
  right: 0;
  top: 0;
  z-index: 1;
  transform: none !important;
}

.red-highlight {
  color: var(--red);
}

.carousel-card {
  background-color: var(--red);
  height: 140px;
  border-radius: 10px;
  width: 100%;
  max-width: 500px;
  padding: 25px;
  display: flex;
  flex-direction: row;
  position: relative;
  overflow: visible;
  margin-top: 8vh;
}

.left-half-carousel-card {
  width: 50%;
  margin-right: 3vw;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
}

.right-half-carousel-card {
  width: 60%;
  position: relative;
  z-index: 3;
  overflow: visible;
}

.carousel-card p {
  color: var(--white);
  font-weight: 500;
}
.indicators {
  margin-top: 2vh;
}
.indicators span {
  margin: 0.2vh 6px;
  height: 10px;
  width: 10px;
  opacity: 0.5;
  border-radius: 50%;
  background-color: var(--faded-orange);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  cursor: pointer;
}
.indicators .active {
  opacity: 1;
  background-color: var(--yellow);
}

@media (max-width: 900px) {
  .indicators {
    margin-top: vh;
  }
  .indicators span {
    height: 16px;
    width: 16px;
    margin: 0.2vh 8px;
  }
}

.carousel-card ul {
  list-style: none;
  padding: 0;
}

.carousel-item {
  background-color: var(--yellow);
  border-radius: 12px;
  padding: 20px 10px;
  width: 170%;
  height: 100px;
  display: flex;
  align-items: center;
  position: absolute;
  right: -45%;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  animation: carouselTransition 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;
  padding: 22px 18px;
}

@media (max-width: 900px) {
  .carousel-item {
    width: 120%;
    right: -20%;
    padding: 15px 20px;
    height: auto;
  }
  .carousel-item p {
    font-size: 13px;
  }
}

@keyframes carouselTransition {
  0% {
    opacity: 0;
    transform: translateY(-50%) scale(0.9) translateX(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) scale(1) translateX(0);
  }
}

.carousel-item p {
  font-weight: 500;
  color: var(--black);
  font-size: 17px;
  line-height: 1.2;
  white-space: normal;
  width: 100%;
  word-break: break-word;
}

#innovation-section-ellipse {
  position: relative;
  left: 0;
  width: 100%;
  z-index: 2;
  pointer-events: none;
  margin-top: -30vh;
}
.innovation-transition {
  background-color: var(--white);
  position: relative;
  width: 100%;
  height: 250px;
  clip-path: ellipse(100% 100% at 50% 0%);
  margin-top: -150px;
  z-index: 1;
  pointer-events: none;
}
/* STATS SECTION */
#stats-section {
  background-color: var(--offWhite);
  margin-top: -100px;
  padding-top: 15vh;
  padding-bottom: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;
  position: relative;
}

.stats-transition {
  background-color: var(--red);
  position: relative;
  width: 100%;
  height: 250px;
  clip-path: ellipse(100% 100% at 50% 100%);
  margin-bottom: -125px;
  z-index: -1;
  pointer-events: none;
}

.stats-globe-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(80vw, 1100px);
  transform: translate(-50%, -50%);
  z-index: 0;
  pointer-events: none;
  opacity: 0.85;
}

@keyframes rotateGlobeRing {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

#stats-section h2 {
  font-size: 60px;
  font-weight: 800;
  margin-bottom: 8vh;
}

.stats-carousel {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stats-display {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 700px;
  overflow: visible;
  padding: 20px 0;
  perspective: 2000px;
}

.stats-track {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 600px;
  transform-style: preserve-3d;
}

.stat-card {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  width: 450px;
  pointer-events: none;
}

@media (max-width: 900px) {
  .stat-card {
    width: 260px;
  }
}

.stat-circle {
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--white);
  transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 30px;
}

.stat-card.active {
  z-index: 100;
  transform: translateX(0) translateZ(300px) scale(1);
  opacity: 1;
  pointer-events: auto;
}

.stat-card.active .stat-circle {
  width: 450px;
  height: 450px;
}

.stat-card.prev {
  z-index: 50;
  transform: translateX(-380px) translateZ(0) scale(0.7);
  opacity: 0.95;
}

.stat-card.next {
  z-index: 50;
  transform: translateX(380px) translateZ(0) scale(0.7);
  opacity: 0.95;
}

.stat-card.back {
  z-index: 10;
  transform: translateX(0) translateZ(-400px) scale(0.5);
  opacity: 0.5;
  filter: blur(4px) grayscale(0.6);
}

.stat-card.prev .stat-circle,
.stat-card.next .stat-circle,
.stat-card.back .stat-circle {
  width: 320px;
  height: 320px;
}

.stat-content {
  display: flex;
  flex-direction: column;
  padding: 10px;
  text-align: center;
}

.stat-count {
  font-weight: 900;
  line-height: 1;
}

.stat-card.active .stat-count {
  font-size: 85px;
  color: black;
}

.stat-card:not(.active) .stat-count {
  font-size: 48px;
}

.stat-label {
  font-weight: 600;
  margin-top: 5px;
}

.stat-card.active .stat-label {
  font-size: 24px;
  color: black;
}

.stat-card:not(.active) .stat-label {
  font-size: 16px;
}

@media (max-width: 900px) {
  .stat-card.active .stat-count {
    font-size: 52px;
  }
  .stat-card:not(.active) .stat-count {
    font-size: 30px;
  }
  .stat-card.active .stat-label {
    font-size: 16px;
  }
  .stat-card:not(.active) .stat-label {
    font-size: 12px;
  }
}

.stat-description {
  max-width: 320px;
  font-size: 15px;
  color: #444;
  line-height: 1.6;
  transition: all 0.6s ease;
}

.stat-card:not(.active) .stat-description {
  opacity: 0;
  transform: translateY(20px);
}

.stats-indicators {
  margin-top: 6vh;
  display: flex;
  gap: 12px;
}

.stats-indicators .dot {
  width: 15px;
  height: 15px;
  background-color: #d1d1d1;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s;
}

.stats-indicators .dot.active {
  background-color: var(--green);
}

/* SCHOLARSHIP SECTION */
#scholarship-section {
  background-color: var(--deep-blue);
  padding: 15vh 0 5vh 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--white);
  position: relative;
}

#scholarship-section::before {
  content: "";
  position: absolute;
  top: -100px;
  left: -10%;
  width: 120%;
  height: 200px;
  background-color: var(--deep-blue);
  border-radius: 50%;
  z-index: 0;
}

#scholarship-section::after {
  content: "";
  position: absolute;
  bottom: -100px;
  /* left: -10%; */
  width: 120%;
  height: 200px;
  background-color: var(--deep-blue);
  border-radius: 50%;
  z-index: 0;
  /* background-color: var(--red); */
  position: relative;
  /* width: 100%; */
  /* height: 250px; */
  clip-path: ellipse(100% 100% at 50% 0%);
  /* margin-top: -125px; */
  z-index: 10;
  pointer-events: none;
}

.scholarship-header {
  text-align: center;
  margin-bottom: 8vh;
  z-index: 2;
  position: relative;
}

.scholarship-header::before {
  content: "";
  position: absolute;
  top: -150px;
  left: 50%;
  transform: translateX(-50%);
  width: 1000px;
  height: 400px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  pointer-events: none;
}

.scholarship-header::after {
  content: "";
  position: absolute;
  top: -200px;
  left: 50%;
  transform: translateX(-50%);
  width: 1200px;
  height: 500px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  pointer-events: none;
}

.scholarship-header h2 {
  font-size: clamp(28px, 5vw, 45px);
  font-weight: 700;
}

.yellow-highlight {
  color: var(--yellow);
}

.scholarship-carousel-container {
  width: 80%;
  max-width: 1200px;
  z-index: 2;
  position: relative;
}

.scholarship-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
}

@media (max-width: 1024px) {
  .scholarship-card {
    flex-direction: column;
    text-align: center;
  }
  .scholarship-content-left {
    order: 2;
    text-align: center;
  }
  .scholarship-content-right {
    order: 1;
  }
  .image-circle-container {
    width: 300px;
    height: 300px;
  }
}

.scholarship-content-left {
  flex: 1.2 1;
  text-align: left;
}

.category-tag {
  display: inline-block;
  border: 1px solid var(--white);
  padding: 8px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 30px;
}

.location-text {
  color: var(--yellow);
  font-size: 12px;
  letter-spacing: 1px;
  margin-bottom: 15px;
  font-weight: 700;
}

.scholarship-content-left h3 {
  font-size: 36px;
  line-height: 1.2;
  margin-bottom: 25px;
  font-weight: 800;
}

.description-text {
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.9;
  margin-bottom: 40px;
  max-width: 500px;
}

.scholarship-nav-indicators {
  display: flex;
  gap: 12px;
}

.nav-dash {
  width: 50px;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-dash.active {
  background-color: #4eb5e5;
}

.scholarship-content-right {
  flex: 0.8 1;
  display: flex;
  justify-content: center;
}

.image-circle-container {
  width: 450px;
  height: 450px;
  border-radius: 50%;
  border: 12px solid var(--yellow);
  overflow: hidden;
  position: relative;
}

@media (max-width: 900px) {
  .image-circle-container {
    width: 280px;
    height: 280px;
    border: 8px solid var(--yellow);
  }
}

.scholarship-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* MOMENTS SECTION */
#moments-section {
  padding: 10vh 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  position: relative;
  z-index: 4;
}

.moments-header {
  margin: 8vh 0;
  text-align: center;
  max-width: 800px;
  padding: 0 20px;
}

.moments-header h2 {
  font-size: clamp(32px, 7vw, 60px);
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 4vh;
}

.moments-intro {
  font-size: 18px;
  line-height: 1.6;
  color: #333;
  padding: 0 20px;
}

.timeline-container {
  position: relative;
  width: 80%;
  max-width: 1000px;
  padding: 50px 0;
}

.timeline-line {
  position: absolute;
  left: 50%;
  top: 62px;
  bottom: 280px;
  width: 4px;
  background-color: var(--yellow);
  transform: translateX(-50%);
  z-index: 1;
}

.timeline-item {
  position: relative;
  width: 50%;
  margin-bottom: 60px;
  z-index: 2;
}

.timeline-item.right {
  left: 50%;
  padding-left: 50px;
}

.timeline-item.left {
  left: 0;
  padding-right: 50px;
  text-align: right;
}

.timeline-item.center {
  width: 100%;
  left: 0;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
  margin-top: 100px;
}

.timeline-dot {
  position: absolute;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  z-index: 3;
}

.timeline-item.right .timeline-dot {
  left: -12px;
}

.timeline-item.left .timeline-dot {
  right: -12px;
}

.timeline-dot.yellow {
  background-color: var(--yellow);
}

.timeline-dot.green {
  background-color: var(--green);
  margin-top: -5vh;
}

.timeline-dot.large {
  width: 40px;
  height: 40px;
}

.timeline-item.center .timeline-dot {
  left: 50%;
  transform: translateX(-50%);
  top: 0;
}

.timeline-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.timeline-tag {
  display: inline-block;
  background-color: var(--yellow);
  color: var(--white);
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  width: fit-content;
}

.timeline-item.left .timeline-tag {
  align-self: flex-end;
}

.timeline-item.center .timeline-tag {
  align-self: center;
}

.timeline-tag.orange {
  background-color: #f39c12;
}

.timeline-tag.green {
  background-color: var(--green);
}

.timeline-content h4 {
  font-size: 24px;
  font-weight: 800;
  color: var(--red);
}

.timeline-content p {
  font-size: 14px;
  line-height: 1.5;
  color: #555;
}

/* MD MESSAGE SECTION */
#md-message-section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.md-message-top {
  background-color: #eeebfe;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1200px;
  background-position: center top;
  padding: 15vh 0 10vh 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 6;
  height: 100vh;
}

.md-message-top::before {
  content: "";
  position: absolute;
  top: -125px;
  left: 0;
  right: 0;
  height: 250px;
  background-color: #eeebfe;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1200px;
  background-position: center top 125px;
  clip-path: ellipse(
    100% 100% at 50% 100%
  ); /* Match hero and stats section curvature style */
  z-index: -1;
}
.md-content-wrapper {
  position: relative;
  z-index: 6;
}

.md-content-wrapper {
  display: flex;
  width: 80%;
  max-width: 1200px;
  align-items: center;
  gap: 50px;
  z-index: 2;
}

.md-text-side {
  flex: 1 1;
}

.md-text-side h2 {
  font-size: 50px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 4vh;
  color: var(--black);
}

/* Custom React-Synced Scrollbar Area */
.md-custom-scrollbar-area {
  display: flex;
  gap: 25px;
  margin-bottom: 4vh;
  max-width: 650px;
  height: 200px;
  position: relative;
}

.md-ui-scrollbar-track {
  width: 20px;
  height: 100%;
  background-color: transparent;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.md-ui-scrollbar-thumb {
  width: 8px;
  background-color: var(--yellow);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 10px;
  transition: top 0.05s ease-out;
  z-index: 3;
  cursor: grab;
  min-height: 28px;
}

.md-ui-scrollbar-thumb:active {
  cursor: grabbing;
}

.md-ui-scrollbar-track::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: 100%;
  background-color: rgba(254, 190, 20, 0.18);
  border-radius: 2px;
  pointer-events: none;
}

/* The Hidden Scroll Container */
.md-scroll-content-container {
  flex: 1 1;
  overflow-y: auto;
  height: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.md-scroll-content-container::-webkit-scrollbar {
  display: none;
}

.md-text-content p {
  font-size: 17px;
  line-height: 1.7;
  color: #444;
  margin-bottom: 20px;
}

.read-more-link {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--black);
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
}

.arrow-down {
  background-color: var(--red);
  color: var(--white);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.md-transition {
  display: none;
}

.md-image-side {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: -450px;
  top: -100px;
  height: 100vh;
  width: 100vh;
}

/* .md-image-side img { */
/*   max-width: 100%; */
/*   height: auto; */
/*   position: absolute; */
/*   right: 0; */
/*   z-index: 7; */
/* } */

.impact-multiplier-badge {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1a1a1a;
  display: flex;
  align-items: center;
  padding: 20px 40px;
  border-radius: 12px;
  z-index: 15;
  gap: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.multiplier-number {
  font-size: clamp(40px, 10vw, 80px);
  font-weight: 900;
  color: var(--green);
  line-height: 1;
}

.multiplier-text {
  background-color: var(--green);
  color: var(--white);
  padding: 15px 25px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
}

.map-transition {
  background-color: var(--red);
  position: relative;
  width: 100%;
  height: 250px;
  margin-top: -120px;
  clip-path: ellipse(100% 100% at 50% 100%);
  margin-bottom: -100px;
  z-index: 7;
  pointer-events: none;
}

.md-message-bottom-map {
  background-color: var(--red);
  padding-top: 10vh;
  padding-bottom: 10vh;
  display: flex;
  justify-content: center;
  color: var(--white);
  position: relative;
  overflow: visible;
  z-index: 6;
}

.md-message-bottom-map::after {
  display: none;
}

.map-container {
  width: 80%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  gap: 80px;
}

@media (max-width: 1024px) {
  .map-container {
    flex-direction: column;
    gap: 40px;
  }
  .md-quote-container {
    justify-content: center;
  }
}

/* =============================================
   DESKTOP EXPLICIT RESTORE — min-width: 769px
   Ensures mobile overrides never bleed up
   ============================================= */
/* @media (min-width: 900px) { */
/*   /* Restore timeline center item to its desktop fully-centered layout */
/*   .timeline-item.center { */
/*     width: 100%; */
/*     left: 0; */
/*     padding-left: 0; */
/*     padding-right: 0; */
/*     text-align: center; */
/*     margin-top: 100px; */
/*     margin-bottom: 60px; */
/*   } */
/*   .timeline-item.center .timeline-dot { */
/*     left: 50%; */
/*     transform: translateX(-50%); */
/*     right: auto; */
/*     top: 0; */
/*   } */
/*   .timeline-item.center .timeline-tag { */
/*     align-self: center; */
/*   } */
/*   /* Restore MD image side to desktop absolute positioning */
/* .md-image-side { */
/*   position: absolute; */
/*   /* right: -450px; */
/*   margin-left: -50vh; */
/*   top: -100px; */
/*   height: 100vh; */
/*   width: 100vh; */
/*   display: flex; */
/*   justify-content: flex-end; */
/*   flex-direction: column; */
/* } */
/* .md-image-side img { */
/*   position: absolute; */
/*   /* right: 0; */
/*   max-width: 100%; */
/*   height: auto; */
/*   z-index: 7; */

/*    }  */
/* } */
/**/
/*Mid-width desktop: pull image in proportionally so it doesn't crowd the text*/
@media (min-width: 769px) and (max-width: 1200px) {
  /*   .md-image-side { */
  /*     top: calc(- (-450px + (1200px - 100vw) * -0.4)); */
  /*     width: 80vh; */
  /*     /* margin-bottom: -40vh; */
  .md-message-top {
    height: auto;
    min-height: unset;
    padding: 8vh 0 10vh 0;
  }
  .md-content-wrapper {
    flex-direction: column;
    width: 88%;
    text-align: left;
    gap: 24px;
    position: static;
  }
  .md-text-side h2 {
    font-size: clamp(28px, 7vw, 42px);
  }
  .md-image-side {
    position: relative;
    right: auto;
    top: auto;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 0;
    margin-bottom: -8vh;
    display: flex;
  }
  .md-image-side img {
    position: static;
    width: 100%;
    max-width: 700px;
    height: auto;
  }
}
/* } */

.map-image-wrapper {
  flex: 1 1;
}

.map-image-wrapper img {
  width: 100%;
  height: auto;
}

.map-info {
  flex: 1 1;
}

.map-info h3 {
  font-size: 45px;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.1;
}

.map-info p {
  font-size: 18px;
  opacity: 0.9;
  margin-bottom: 40px;
}

.hub-locations-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
}

.hub-location {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--yellow);
}

.location-dot-wrap {
  display: flex;
  padding: 5px;
  border-radius: 50%;
  border: 1px solid var(--yellow);
}

.location-dot {
  width: 15px;
  height: 15px;
  min-width: 15px;
  background-color: var(--yellow);
  border-radius: 50%;
  flex-shrink: 0;
  padding: 5px;
}

/* FOOTER CTA SECTION */
#footer-cta {
  background-color: var(--black);
  padding: 15vh 0 5vh 0;
  color: var(--white);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-container {
  width: 80%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10vh;
}

.footer-content-left {
  flex: 1.5 1;
  text-align: left;
}

.footer-content-left h2 {
  font-size: 35px;
  font-weight: 800;
  line-height: 1.3;
  margin-bottom: 30px;
}

.footer-content-left p {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 40px;
  opacity: 0.9;
}

.download-btn {
  background-color: var(--red);
  color: var(--white);
  border: none;
  padding: 18px 35px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.download-btn:hover {
  transform: scale(1.05);
}

.footer-content-right {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
}

.footer-visual {
  width: 120%;
  max-width: 600px;
  height: auto;
  transform: translateX(10%);
}

.footer-bottom {
  width: 80%;
  max-width: 1200px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 40px;
  font-size: 14px;
  opacity: 0.7;
  text-align: left;
}

/* =============================================
   MOBILE RESPONSIVE — max-width: 768px
   ============================================= */
@media (max-width: 768px) {
  /* --- HERO --- */
  .hero-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .hero-header img {
    height: 40px;
  }
  .hero-header button {
    width: auto;
    height: auto;
    padding: 10px 16px;
    font-size: 13px;
    white-space: nowrap;
  }
  .hero-body {
    width: 90%;
    padding: 6vh 16px;
  }
  .hero-body p {
    font-size: clamp(14px, 4vw, 20px);
    margin: 12px 0;
  }

  /* --- INNOVATION --- */
  .innovation-section {
    flex-direction: column;
    width: 90%;
    padding: 8vh 0 6vh 0;
    gap: 24px;
  }
  .left-panel,
  #innovation-section-ellipse {
    display: none;
  }
  .right-panel h2 {
    font-size: clamp(22px, 5vw, 32px);
    padding-bottom: 2vh;
  }
  .carousel-card {
    margin-top: 4vh;
    height: auto;
    min-height: 120px;
  }
  .carousel-item {
    width: 110%;
    right: -15%;
    padding: 12px 16px;
    height: auto;
  }
  .carousel-item p {
    font-size: 12px;
  }

  /* --- STATS --- */
  /* On mobile, hide the innovation transition elements that create negative-margin overlap */
  .innovation-transition {
    display: none;
  }
  #innovation-section-ellipse {
    display: none;
  }
  #stats-section {
    overflow-x: hidden;
    margin-top: 0;
    padding-top: 8vh;
    padding-bottom: 20vh; /* extra room so indicators clear scholarship top ellipse */
  }
  #stats-section h2 {
    font-size: clamp(28px, 8vw, 48px);
    margin-bottom: 4vh;
    padding: 0 20px;
  }
  .stats-globe-ring {
    display: none;
  }
  .stats-display {
    min-height: auto;
    padding: 10px 0;
  }
  .stats-track {
    height: 420px;
  }
  .stat-card {
    width: 240px;
  }
  .stat-card.active .stat-circle {
    width: 260px;
    height: 260px;
  }
  .stat-card.prev .stat-circle,
  .stat-card.next .stat-circle,
  .stat-card.back .stat-circle {
    width: 180px;
    height: 180px;
  }
  .stat-card.prev {
    transform: translateX(-140px) translateZ(-100px) scale(0.6);
  }
  .stat-card.next {
    transform: translateX(140px) translateZ(-100px) scale(0.6);
  }
  .stat-card.back {
    display: none;
  }
  .stat-card.active .stat-count {
    font-size: 44px;
  }
  .stat-card:not(.active) .stat-count {
    font-size: 26px;
  }
  .stat-card.active .stat-label {
    font-size: 14px;
  }
  .stat-card:not(.active) .stat-label {
    font-size: 11px;
  }
  .stat-description {
    font-size: 13px;
    max-width: 240px;
    padding: 0 8px;
  }

  /* --- SCHOLARSHIP --- */
  /* #scholarship-section { */
  /*   /* padding: 12vh 0 8vh 0; */
  */
  /* } */
  .scholarship-carousel-container {
    width: 88%;
  }
  .scholarship-card {
    flex-direction: column;
    text-align: center;
    gap: 30px;
  }
  .scholarship-content-left {
    order: 2;
    text-align: center;
  }
  .scholarship-content-right {
    order: 1;
  }
  .scholarship-content-left h3 {
    font-size: clamp(22px, 5vw, 32px);
  }
  .description-text {
    font-size: 15px;
    max-width: 100%;
  }
  .scholarship-nav-indicators {
    justify-content: center;
  }
  .image-circle-container {
    width: 240px;
    height: 240px;
    border-width: 7px;
  }

  /* --- MOMENTS / TIMELINE --- */
  #moments-section {
    padding: 16vh 0 6vh 0; /* extra top clears scholarship bottom ellipse */
  }
  .moments-intro {
    font-size: 15px;
    padding: 0 8px;
  }
  .timeline-container {
    width: 90%;
    padding: 30px 0;
  }
  /* Move line to left edge on mobile */
  .timeline-line {
    left: 12px;
    top: 30px;
    bottom: 50vh;
    transform: none;
    height: 65%;
  }
  /* All items go full-width, aligned to the left line */
  .timeline-item.right,
  .timeline-item.left,
  .timeline-item.center {
    width: 100%;
    left: 0;
    padding-left: 44px;
    padding-right: 0;
    text-align: left;
    margin-top: 0;
    margin-bottom: 40px;
  }
  .timeline-dot.green {
    background-color: var(--green);
    margin-top: -10px;
  }
  /* All dots sit on the left line */
  .timeline-item.right .timeline-dot,
  .timeline-item.left .timeline-dot {
    left: 0px;
    right: auto;
  }
  /* Large center dot: align to left line (dot is 40px wide, offset by half = -8px from item's left:0) */
  .timeline-item.center .timeline-dot {
    left: -8px;
    transform: none;
    right: auto;
  }
  /* Tags left-aligned for all items on mobile */
  .timeline-item.left .timeline-tag,
  .timeline-item.center .timeline-tag {
    align-self: flex-start;
  }
  .timeline-content h4 {
    font-size: 18px;
  }
  .timeline-content p {
    font-size: 13px;
    margin-bottom: 2vh;
  }

  .map-transition {
    margin-top: -40px;
    height: 160px;
  }
  .md-message-top {
    height: auto;
    min-height: unset;
    padding: 8vh 0 10vh 0;
  }
  .md-content-wrapper {
    flex-direction: column;
    width: 88%;
    text-align: left;
    gap: 24px;
    position: static;
  }
  .md-text-side h2 {
    font-size: clamp(28px, 7vw, 42px);
  }
  /* Stack image naturally below text */
  .md-image-side {
    position: relative;
    right: auto;
    top: auto;
    width: 100%;
    height: auto;
    justify-content: center;
    margin-top: 0;
    margin-bottom: -8vh;
    display: flex;
  }
  .md-image-side img {
    position: static;
    width: 70%;
    max-width: 300px;
    height: auto;
  }
  /* Scrollbar text area */
  .md-custom-scrollbar-area {
    max-width: 100%;
    height: 160px;
  }
  .md-text-content p {
    font-size: 15px;
  }

  /* --- IMPACT BADGE --- */
  .impact-multiplier-badge {
    width: 88%;
    padding: 16px 20px;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    top: 40px;
  }
  .multiplier-number {
    font-size: clamp(36px, 10vw, 60px);
  }
  .multiplier-text {
    font-size: 14px;
    padding: 12px 18px;
  }

  /* --- MAP SECTION --- */
  .md-message-bottom-map {
    margin-top: 10vh;
    padding-top: 100px;
    padding-bottom: 8vh;
  }
  .map-container {
    flex-direction: column-reverse;
    width: 88%;
    gap: 30px;
  }
  .map-info h3 {
    font-size: clamp(26px, 6vw, 38px);
  }
  /* .map-info p { */
  /*   font-size: 15px; */
  /* } */
  /* .hub-locations-grid { */
  /*   font-size: 16px; */
  /*   gap: 14px; */
  /*   padding: 0; */
  /* } */
  /* .location-dot { */
  /*   width: 11px; */
  /*   height: 11px; */
  /* } */

  /* --- FOOTER --- */
  #footer-cta {
    padding: 10vh 0 5vh 0;
  }
  .footer-container {
    flex-direction: column;
    text-align: center;
    gap: 30px;
    margin-bottom: 6vh;
  }
  .footer-content-left {
    text-align: center;
  }
  .footer-content-left h2 {
    font-size: clamp(22px, 6vw, 32px);
  }
  .footer-content-left p {
    font-size: 15px;
  }
  .footer-content-right {
    display: none;
  }
  .download-btn {
    font-size: 15px;
    padding: 14px 28px;
    width: 100%;
    max-width: 320px;
  }
  .footer-bottom {
    text-align: center;
    font-size: 12px;
  }
}

/* =============================================
   EXTRA SMALL — max-width: 480px
   ============================================= */
@media (max-width: 480px) {
  .hero-header button {
    padding: 8px 12px;
    font-size: 11px;
  }
  .hero-header img {
    height: 32px;
  }
  .stats-track {
    height: 380px;
  }
  .stat-card.active .stat-circle {
    width: 220px;
    height: 220px;
  }
  .stat-card.prev .stat-circle,
  .stat-card.next .stat-circle {
    width: 150px;
    height: 150px;
  }
  .stat-card.prev {
    transform: translateX(-110px) translateZ(-100px) scale(0.55);
  }
  .stat-card.next {
    transform: translateX(110px) translateZ(-100px) scale(0.55);
  }
  .stat-card.active .stat-count {
    font-size: 36px;
  }
  .image-circle-container {
    width: 200px;
    height: 200px;
  }
  .impact-multiplier-badge {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT;;wEAEsE;EACtE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;sEACoE;AACtE;;AAEA,iBAAiB;;AAEjB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAO;EACP,YAAY;EACZ,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE;IACE,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,+BAA+B;IAC/B,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,0CAA0C;EAC1C,oEAAoE;EACpE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,uDAAuD;EACzD;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,qBAAqB;EACrB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sDAAsD;EACtD,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;EAGE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,wBAAwB;EACxB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,WAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;EACjC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,aAAa;EACb,UAAU;EACV,+BAA+B;EAC/B,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yDAA4D;EAC5D,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,yDAA4D;EAC5D,uBAAuB;EACvB,qCAAqC;EACrC;;GAEC,EAAE,iDAAiD;EACpD,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA,yBAAyB;AACzB,uBAAuB;AACvB,oBAAoB;AACpB,0BAA0B;AAC1B,gBAAgB;AAChB,kBAAkB;AAClB,MAAM;;AAEN;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,qBAAqB;EACrB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;;;kDAGkD;AAClD,gCAAgC;AAChC,2EAA2E;AAC3E,8BAA8B;AAC9B,qBAAqB;AACrB,iBAAiB;AACjB,yBAAyB;AACzB,0BAA0B;AAC1B,4BAA4B;AAC5B,2BAA2B;AAC3B,6BAA6B;AAC7B,QAAQ;AACR,4CAA4C;AAC5C,mBAAmB;AACnB,qCAAqC;AACrC,qBAAqB;AACrB,gBAAgB;AAChB,QAAQ;AACR,4CAA4C;AAC5C,4BAA4B;AAC5B,QAAQ;AACR,+DAA+D;AAC/D,qBAAqB;AACrB,0BAA0B;AAC1B,wBAAwB;AACxB,0BAA0B;AAC1B,mBAAmB;AACnB,qBAAqB;AACrB,oBAAoB;AACpB,qBAAqB;AACrB,iCAAiC;AACjC,8BAA8B;AAC9B,MAAM;AACN,yBAAyB;AACzB,0BAA0B;AAC1B,mBAAmB;AACnB,uBAAuB;AACvB,oBAAoB;AACpB,kBAAkB;;AAElB,UAAU;AACV,MAAM;AACN,GAAG;AACH,+EAA+E;AAC/E;EACE,uBAAuB;EACvB,yDAAyD;EACzD,qBAAqB;EACrB,iCAAiC;EACjC;IACE,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;AACF;AACA,MAAM;;AAEN;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,8CAA8C;EAC9C,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE,iBAAiB;EACjB;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,iCAAiC;IACjC,cAAc;EAChB;;EAEA,uBAAuB;EACvB;IACE,sBAAsB;IACtB,UAAU;IACV,oBAAoB;IACpB,SAAS;EACX;EACA;;IAEE,aAAa;EACf;EACA;IACE,iCAAiC;IACjC,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,eAAe;EACjB;;EAEA,kBAAkB;EAClB,2FAA2F;EAC3F;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,oBAAoB,EAAE,2DAA2D;EACnF;EACA;IACE,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;;;IAGE,YAAY;IACZ,aAAa;EACf;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA,wBAAwB;EACxB,2BAA2B;EAC3B,gCAAgC;EAChC;;;IAGE,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,QAAQ;IACR,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,iCAAiC;EACnC;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,qBAAqB,EAAE,gDAAgD;EACzE;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA,qCAAqC;EACrC;IACE,UAAU;IACV,SAAS;IACT,YAAY;IACZ,eAAe;IACf,WAAW;EACb;EACA,sDAAsD;EACtD;;;IAGE,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;EACA,kCAAkC;EAClC;;IAEE,SAAS;IACT,WAAW;EACb;EACA,sGAAsG;EACtG;IACE,UAAU;IACV,eAAe;IACf,WAAW;EACb;EACA,8CAA8C;EAC9C;;IAEE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,iCAAiC;EACnC;EACA,qCAAqC;EACrC;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;EACA,wBAAwB;EACxB;IACE,eAAe;IACf,aAAa;EACf;EACA;IACE,eAAe;EACjB;;EAEA,yBAAyB;EACzB;IACE,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,kCAAkC;EACpC;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA,wBAAwB;EACxB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,UAAU;IACV,SAAS;EACX;EACA;IACE,iCAAiC;EACnC;EACA,kBAAkB;EAClB,uBAAuB;EACvB,MAAM;EACN,0BAA0B;EAC1B,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,MAAM;;EAEN,mBAAmB;EACnB;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;;kDAEkD;AAClD;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;;IAEE,YAAY;IACZ,aAAa;EACf;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  overflow-x: hidden;\n  width: 100%;\n  position: relative;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --red: #d22310;\n  --navy: #1a2744;\n  --yellow: #febe14;\n  --white: #ffffff;\n  --black: #000000;\n  --offWhite: #fff5f4;\n  --green: #bad530;\n  --purple: #7c68ee;\n  --deep-blue: #275ac3;\n  --faded-orange: #fed6a3;\n}\n\nbody {\n  margin: 0;\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family:\n    source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n/* HERO SECTION */\n\n#hero-section {\n  position: relative;\n  background-color: var(--red);\n  min-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 8px;\n}\n\n.hero-patterns-left,\n.hero-patterns-right {\n  margin: 4vh 0;\n  position: absolute;\n  top: 50%;\n  height: auto;\n  width: min(34vw, 520px);\n  max-width: 520px;\n  z-index: 0;\n  pointer-events: none;\n  height: 100%;\n  z-index: 3;\n}\n\n.hero-patterns-left {\n  left: -12%;\n  transform: translateY(-50%) scaleX(-1);\n  transform-origin: center center;\n}\n\n.hero-patterns-right {\n  right: -12%;\n  transform: translateY(-50%);\n  transform-origin: center center;\n}\n\n.hero-header {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  width: 90%;\n  margin-top: 4vh;\n  justify-content: space-between;\n  align-items: center;\n}\n.hero-header img {\n  height: 60px;\n}\n\n.hero-body {\n  position: relative;\n  z-index: 3;\n  flex: 7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 10vh 20px;\n  width: 80%;\n  max-width: 1200px;\n}\n\n.hero-body p {\n  text-align: center;\n  color: var(--white);\n  font-size: clamp(18px, 4vw, 30px);\n  margin: 20px 0;\n}\n\n#hero-mini-title {\n  font-weight: 1000;\n}\n.hero-body h1 {\n  text-align: center;\n  color: var(--white);\n  font-size: clamp(48px, 10vw, 120px);\n  line-height: 1;\n}\n.orange-highlight {\n  color: var(--faded-orange);\n}\n\n.hero-transition {\n  background-color: var(--red);\n  position: relative;\n  width: 100%;\n  height: 250px;\n  clip-path: ellipse(100% 100% at 50% 0%);\n  margin-top: -125px;\n  z-index: -1;\n  pointer-events: none;\n  transition: 0.2s;\n}\n@media (min-width: 901px) {\n  .hero-header button {\n    background-color: var(--yellow);\n    border: none;\n    color: var(--white);\n    width: 223px;\n    height: 54px;\n    font-size: 2vh;\n    font-weight: 800;\n    border-radius: 10px;\n    transition: transform 0.2s;\n  }\n  .hero-header button:hover {\n    transform: scale(1.05);\n  }\n\n  #mobile-download-button {\n    display: none;\n  }\n}\n@media (max-width: 900px) {\n  .hero-patterns-left {\n    left: -30%;\n  }\n  .hero-patterns-right {\n    right: -30%;\n  }\n  #mobile-download-button {\n    background-color: var(--yellow);\n    border: none;\n    color: var(--white);\n    width: 223px;\n    height: 54px;\n    font-size: 2vh;\n    font-weight: 800;\n    border-radius: 10px;\n    transition: transform 0.2s;\n  }\n  #mobile-download-button:hover {\n    transform: scale(1.05);\n  }\n  .hero-header button {\n    display: none;\n  }\n}\n\n/* INNOVATION SECTION */\n.innovation-section {\n  padding: 15vh 0 10vh 0;\n  z-index: 3;\n  overflow: hidden;\n  display: flex;\n  justify-self: center;\n  flex-direction: row;\n  width: 80%;\n  gap: 40px;\n  position: relative;\n}\n.right-panel {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.right-panel h2 {\n  font-size: 40px;\n  padding-bottom: 4vh;\n  line-height: 5vh;\n  padding: 0 3vh;\n}\n.left-panel {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  overflow: visible;\n}\n\n.left-panel img {\n  position: relative;\n  width: 100%;\n  max-width: 620px;\n  right: 0;\n  top: 0;\n  z-index: 1;\n  transform: none !important;\n}\n\n.red-highlight {\n  color: var(--red);\n}\n\n.carousel-card {\n  background-color: var(--red);\n  height: 140px;\n  border-radius: 10px;\n  width: 100%;\n  max-width: 500px;\n  padding: 25px;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  overflow: visible;\n  margin-top: 8vh;\n}\n\n.left-half-carousel-card {\n  width: 50%;\n  margin-right: 3vw;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 2;\n}\n\n.right-half-carousel-card {\n  width: 60%;\n  position: relative;\n  z-index: 3;\n  overflow: visible;\n}\n\n.carousel-card p {\n  color: var(--white);\n  font-weight: 500;\n}\n.indicators {\n  margin-top: 2vh;\n}\n.indicators span {\n  margin: 0.2vh 6px;\n  height: 10px;\n  width: 10px;\n  opacity: 0.5;\n  border-radius: 50%;\n  background-color: var(--faded-orange);\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 3;\n  cursor: pointer;\n}\n.indicators .active {\n  opacity: 1;\n  background-color: var(--yellow);\n}\n\n@media (max-width: 900px) {\n  .indicators {\n    margin-top: vh;\n  }\n  .indicators span {\n    height: 16px;\n    width: 16px;\n    margin: 0.2vh 8px;\n  }\n}\n\n.carousel-card ul {\n  list-style: none;\n  padding: 0;\n}\n\n.carousel-item {\n  background-color: var(--yellow);\n  border-radius: 12px;\n  padding: 20px 10px;\n  width: 170%;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  position: absolute;\n  right: -45%;\n  top: 50%;\n  transform: translateY(-50%);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);\n  animation: carouselTransition 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n  overflow: hidden;\n  padding: 22px 18px;\n}\n\n@media (max-width: 900px) {\n  .carousel-item {\n    width: 120%;\n    right: -20%;\n    padding: 15px 20px;\n    height: auto;\n  }\n  .carousel-item p {\n    font-size: 13px;\n  }\n}\n\n@keyframes carouselTransition {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) scale(0.9) translateX(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) scale(1) translateX(0);\n  }\n}\n\n.carousel-item p {\n  font-weight: 500;\n  color: var(--black);\n  font-size: 17px;\n  line-height: 1.2;\n  white-space: normal;\n  width: 100%;\n  word-break: break-word;\n}\n\n#innovation-section-ellipse {\n  position: relative;\n  left: 0;\n  width: 100%;\n  z-index: 2;\n  pointer-events: none;\n  margin-top: -30vh;\n}\n.innovation-transition {\n  background-color: var(--white);\n  position: relative;\n  width: 100%;\n  height: 250px;\n  clip-path: ellipse(100% 100% at 50% 0%);\n  margin-top: -150px;\n  z-index: 1;\n  pointer-events: none;\n}\n/* STATS SECTION */\n#stats-section {\n  background-color: var(--offWhite);\n  margin-top: -100px;\n  padding-top: 15vh;\n  padding-bottom: 20vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.stats-transition {\n  background-color: var(--red);\n  position: relative;\n  width: 100%;\n  height: 250px;\n  clip-path: ellipse(100% 100% at 50% 100%);\n  margin-bottom: -125px;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.stats-globe-ring {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: min(80vw, 1100px);\n  transform: translate(-50%, -50%);\n  z-index: 0;\n  pointer-events: none;\n  opacity: 0.85;\n}\n\n@keyframes rotateGlobeRing {\n  from {\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n#stats-section h2 {\n  font-size: 60px;\n  font-weight: 800;\n  margin-bottom: 8vh;\n}\n\n.stats-carousel {\n  width: 100%;\n  max-width: 1400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stats-display {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 700px;\n  overflow: visible;\n  padding: 20px 0;\n  perspective: 2000px;\n}\n\n.stats-track {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 600px;\n  transform-style: preserve-3d;\n}\n\n.stat-card {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  width: 450px;\n  pointer-events: none;\n}\n\n@media (max-width: 900px) {\n  .stat-card {\n    width: 260px;\n  }\n}\n\n.stat-circle {\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: var(--white);\n  transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-bottom: 30px;\n}\n\n.stat-card.active {\n  z-index: 100;\n  transform: translateX(0) translateZ(300px) scale(1);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.stat-card.active .stat-circle {\n  width: 450px;\n  height: 450px;\n}\n\n.stat-card.prev {\n  z-index: 50;\n  transform: translateX(-380px) translateZ(0) scale(0.7);\n  opacity: 0.95;\n}\n\n.stat-card.next {\n  z-index: 50;\n  transform: translateX(380px) translateZ(0) scale(0.7);\n  opacity: 0.95;\n}\n\n.stat-card.back {\n  z-index: 10;\n  transform: translateX(0) translateZ(-400px) scale(0.5);\n  opacity: 0.5;\n  filter: blur(4px) grayscale(0.6);\n}\n\n.stat-card.prev .stat-circle,\n.stat-card.next .stat-circle,\n.stat-card.back .stat-circle {\n  width: 320px;\n  height: 320px;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  text-align: center;\n}\n\n.stat-count {\n  font-weight: 900;\n  line-height: 1;\n}\n\n.stat-card.active .stat-count {\n  font-size: 85px;\n  color: black;\n}\n\n.stat-card:not(.active) .stat-count {\n  font-size: 48px;\n}\n\n.stat-label {\n  font-weight: 600;\n  margin-top: 5px;\n}\n\n.stat-card.active .stat-label {\n  font-size: 24px;\n  color: black;\n}\n\n.stat-card:not(.active) .stat-label {\n  font-size: 16px;\n}\n\n@media (max-width: 900px) {\n  .stat-card.active .stat-count {\n    font-size: 52px;\n  }\n  .stat-card:not(.active) .stat-count {\n    font-size: 30px;\n  }\n  .stat-card.active .stat-label {\n    font-size: 16px;\n  }\n  .stat-card:not(.active) .stat-label {\n    font-size: 12px;\n  }\n}\n\n.stat-description {\n  max-width: 320px;\n  font-size: 15px;\n  color: #444;\n  line-height: 1.6;\n  transition: all 0.6s ease;\n}\n\n.stat-card:not(.active) .stat-description {\n  opacity: 0;\n  transform: translateY(20px);\n}\n\n.stats-indicators {\n  margin-top: 6vh;\n  display: flex;\n  gap: 12px;\n}\n\n.stats-indicators .dot {\n  width: 15px;\n  height: 15px;\n  background-color: #d1d1d1;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.stats-indicators .dot.active {\n  background-color: var(--green);\n}\n\n/* SCHOLARSHIP SECTION */\n#scholarship-section {\n  background-color: var(--deep-blue);\n  padding: 15vh 0 5vh 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--white);\n  position: relative;\n}\n\n#scholarship-section::before {\n  content: \"\";\n  position: absolute;\n  top: -100px;\n  left: -10%;\n  width: 120%;\n  height: 200px;\n  background-color: var(--deep-blue);\n  border-radius: 50%;\n  z-index: 0;\n}\n\n#scholarship-section::after {\n  content: \"\";\n  position: absolute;\n  bottom: -100px;\n  /* left: -10%; */\n  width: 120%;\n  height: 200px;\n  background-color: var(--deep-blue);\n  border-radius: 50%;\n  z-index: 0;\n  /* background-color: var(--red); */\n  position: relative;\n  /* width: 100%; */\n  /* height: 250px; */\n  clip-path: ellipse(100% 100% at 50% 0%);\n  /* margin-top: -125px; */\n  z-index: 10;\n  pointer-events: none;\n}\n\n.scholarship-header {\n  text-align: center;\n  margin-bottom: 8vh;\n  z-index: 2;\n  position: relative;\n}\n\n.scholarship-header::before {\n  content: \"\";\n  position: absolute;\n  top: -150px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 1000px;\n  height: 400px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.scholarship-header::after {\n  content: \"\";\n  position: absolute;\n  top: -200px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 1200px;\n  height: 500px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.scholarship-header h2 {\n  font-size: clamp(28px, 5vw, 45px);\n  font-weight: 700;\n}\n\n.yellow-highlight {\n  color: var(--yellow);\n}\n\n.scholarship-carousel-container {\n  width: 80%;\n  max-width: 1200px;\n  z-index: 2;\n  position: relative;\n}\n\n.scholarship-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 50px;\n}\n\n@media (max-width: 1024px) {\n  .scholarship-card {\n    flex-direction: column;\n    text-align: center;\n  }\n  .scholarship-content-left {\n    order: 2;\n    text-align: center;\n  }\n  .scholarship-content-right {\n    order: 1;\n  }\n  .image-circle-container {\n    width: 300px;\n    height: 300px;\n  }\n}\n\n.scholarship-content-left {\n  flex: 1.2;\n  text-align: left;\n}\n\n.category-tag {\n  display: inline-block;\n  border: 1px solid var(--white);\n  padding: 8px 24px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 2px;\n  margin-bottom: 30px;\n}\n\n.location-text {\n  color: var(--yellow);\n  font-size: 12px;\n  letter-spacing: 1px;\n  margin-bottom: 15px;\n  font-weight: 700;\n}\n\n.scholarship-content-left h3 {\n  font-size: 36px;\n  line-height: 1.2;\n  margin-bottom: 25px;\n  font-weight: 800;\n}\n\n.description-text {\n  font-size: 16px;\n  line-height: 1.6;\n  opacity: 0.9;\n  margin-bottom: 40px;\n  max-width: 500px;\n}\n\n.scholarship-nav-indicators {\n  display: flex;\n  gap: 12px;\n}\n\n.nav-dash {\n  width: 50px;\n  height: 5px;\n  background-color: rgba(255, 255, 255, 0.3);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.nav-dash.active {\n  background-color: #4eb5e5;\n}\n\n.scholarship-content-right {\n  flex: 0.8;\n  display: flex;\n  justify-content: center;\n}\n\n.image-circle-container {\n  width: 450px;\n  height: 450px;\n  border-radius: 50%;\n  border: 12px solid var(--yellow);\n  overflow: hidden;\n  position: relative;\n}\n\n@media (max-width: 900px) {\n  .image-circle-container {\n    width: 280px;\n    height: 280px;\n    border: 8px solid var(--yellow);\n  }\n}\n\n.scholarship-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* MOMENTS SECTION */\n#moments-section {\n  padding: 10vh 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: var(--white);\n  position: relative;\n  z-index: 4;\n}\n\n.moments-header {\n  margin: 8vh 0;\n  text-align: center;\n  max-width: 800px;\n  padding: 0 20px;\n}\n\n.moments-header h2 {\n  font-size: clamp(32px, 7vw, 60px);\n  font-weight: 800;\n  line-height: 1.1;\n  margin-bottom: 4vh;\n}\n\n.moments-intro {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #333;\n  padding: 0 20px;\n}\n\n.timeline-container {\n  position: relative;\n  width: 80%;\n  max-width: 1000px;\n  padding: 50px 0;\n}\n\n.timeline-line {\n  position: absolute;\n  left: 50%;\n  top: 62px;\n  bottom: 280px;\n  width: 4px;\n  background-color: var(--yellow);\n  transform: translateX(-50%);\n  z-index: 1;\n}\n\n.timeline-item {\n  position: relative;\n  width: 50%;\n  margin-bottom: 60px;\n  z-index: 2;\n}\n\n.timeline-item.right {\n  left: 50%;\n  padding-left: 50px;\n}\n\n.timeline-item.left {\n  left: 0;\n  padding-right: 50px;\n  text-align: right;\n}\n\n.timeline-item.center {\n  width: 100%;\n  left: 0;\n  padding-left: 0;\n  padding-right: 0;\n  text-align: center;\n  margin-top: 100px;\n}\n\n.timeline-dot {\n  position: absolute;\n  top: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  z-index: 3;\n}\n\n.timeline-item.right .timeline-dot {\n  left: -12px;\n}\n\n.timeline-item.left .timeline-dot {\n  right: -12px;\n}\n\n.timeline-dot.yellow {\n  background-color: var(--yellow);\n}\n\n.timeline-dot.green {\n  background-color: var(--green);\n  margin-top: -5vh;\n}\n\n.timeline-dot.large {\n  width: 40px;\n  height: 40px;\n}\n\n.timeline-item.center .timeline-dot {\n  left: 50%;\n  transform: translateX(-50%);\n  top: 0;\n}\n\n.timeline-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.timeline-tag {\n  display: inline-block;\n  background-color: var(--yellow);\n  color: var(--white);\n  padding: 4px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  width: fit-content;\n}\n\n.timeline-item.left .timeline-tag {\n  align-self: flex-end;\n}\n\n.timeline-item.center .timeline-tag {\n  align-self: center;\n}\n\n.timeline-tag.orange {\n  background-color: #f39c12;\n}\n\n.timeline-tag.green {\n  background-color: var(--green);\n}\n\n.timeline-content h4 {\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--red);\n}\n\n.timeline-content p {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #555;\n}\n\n/* MD MESSAGE SECTION */\n#md-message-section {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.md-message-top {\n  background-color: #eeebfe;\n  background-image: url(\"./assets/images/CcHUB_Pattern_1.svg\");\n  background-size: 1200px;\n  background-position: center top;\n  padding: 15vh 0 10vh 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  z-index: 6;\n  height: 100vh;\n}\n\n.md-message-top::before {\n  content: \"\";\n  position: absolute;\n  top: -125px;\n  left: 0;\n  right: 0;\n  height: 250px;\n  background-color: #eeebfe;\n  background-image: url(\"./assets/images/CcHUB_Pattern_1.svg\");\n  background-size: 1200px;\n  background-position: center top 125px;\n  clip-path: ellipse(\n    100% 100% at 50% 100%\n  ); /* Match hero and stats section curvature style */\n  z-index: -1;\n}\n.md-content-wrapper {\n  position: relative;\n  z-index: 6;\n}\n\n.md-content-wrapper {\n  display: flex;\n  width: 80%;\n  max-width: 1200px;\n  align-items: center;\n  gap: 50px;\n  z-index: 2;\n}\n\n.md-text-side {\n  flex: 1;\n}\n\n.md-text-side h2 {\n  font-size: 50px;\n  font-weight: 800;\n  line-height: 1.1;\n  margin-bottom: 4vh;\n  color: var(--black);\n}\n\n/* Custom React-Synced Scrollbar Area */\n.md-custom-scrollbar-area {\n  display: flex;\n  gap: 25px;\n  margin-bottom: 4vh;\n  max-width: 650px;\n  height: 200px;\n  position: relative;\n}\n\n.md-ui-scrollbar-track {\n  width: 20px;\n  height: 100%;\n  background-color: transparent;\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.md-ui-scrollbar-thumb {\n  width: 8px;\n  background-color: var(--yellow);\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  border-radius: 10px;\n  transition: top 0.05s ease-out;\n  z-index: 3;\n  cursor: grab;\n  min-height: 28px;\n}\n\n.md-ui-scrollbar-thumb:active {\n  cursor: grabbing;\n}\n\n.md-ui-scrollbar-track::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 2px;\n  height: 100%;\n  background-color: rgba(254, 190, 20, 0.18);\n  border-radius: 2px;\n  pointer-events: none;\n}\n\n/* The Hidden Scroll Container */\n.md-scroll-content-container {\n  flex: 1;\n  overflow-y: auto;\n  height: 100%;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.md-scroll-content-container::-webkit-scrollbar {\n  display: none;\n}\n\n.md-text-content p {\n  font-size: 17px;\n  line-height: 1.7;\n  color: #444;\n  margin-bottom: 20px;\n}\n\n.read-more-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--black);\n  text-decoration: none;\n  font-weight: 700;\n  font-size: 16px;\n}\n\n.arrow-down {\n  background-color: var(--red);\n  color: var(--white);\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n}\n\n.md-transition {\n  display: none;\n}\n\n.md-image-side {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  right: -450px;\n  top: -100px;\n  height: 100vh;\n  width: 100vh;\n}\n\n/* .md-image-side img { */\n/*   max-width: 100%; */\n/*   height: auto; */\n/*   position: absolute; */\n/*   right: 0; */\n/*   z-index: 7; */\n/* } */\n\n.impact-multiplier-badge {\n  position: absolute;\n  top: 60px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #1a1a1a;\n  display: flex;\n  align-items: center;\n  padding: 20px 40px;\n  border-radius: 12px;\n  z-index: 15;\n  gap: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n.multiplier-number {\n  font-size: clamp(40px, 10vw, 80px);\n  font-weight: 900;\n  color: var(--green);\n  line-height: 1;\n}\n\n.multiplier-text {\n  background-color: var(--green);\n  color: var(--white);\n  padding: 15px 25px;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1.3;\n}\n\n.map-transition {\n  background-color: var(--red);\n  position: relative;\n  width: 100%;\n  height: 250px;\n  margin-top: -120px;\n  clip-path: ellipse(100% 100% at 50% 100%);\n  margin-bottom: -100px;\n  z-index: 7;\n  pointer-events: none;\n}\n\n.md-message-bottom-map {\n  background-color: var(--red);\n  padding-top: 10vh;\n  padding-bottom: 10vh;\n  display: flex;\n  justify-content: center;\n  color: var(--white);\n  position: relative;\n  overflow: visible;\n  z-index: 6;\n}\n\n.md-message-bottom-map::after {\n  display: none;\n}\n\n.map-container {\n  width: 80%;\n  max-width: 1200px;\n  display: flex;\n  align-items: center;\n  gap: 80px;\n}\n\n@media (max-width: 1024px) {\n  .map-container {\n    flex-direction: column;\n    gap: 40px;\n  }\n  .md-quote-container {\n    justify-content: center;\n  }\n}\n\n/* =============================================\n   DESKTOP EXPLICIT RESTORE — min-width: 769px\n   Ensures mobile overrides never bleed up\n   ============================================= */\n/* @media (min-width: 900px) { */\n/*   /* Restore timeline center item to its desktop fully-centered layout */\n/*   .timeline-item.center { */\n/*     width: 100%; */\n/*     left: 0; */\n/*     padding-left: 0; */\n/*     padding-right: 0; */\n/*     text-align: center; */\n/*     margin-top: 100px; */\n/*     margin-bottom: 60px; */\n/*   } */\n/*   .timeline-item.center .timeline-dot { */\n/*     left: 50%; */\n/*     transform: translateX(-50%); */\n/*     right: auto; */\n/*     top: 0; */\n/*   } */\n/*   .timeline-item.center .timeline-tag { */\n/*     align-self: center; */\n/*   } */\n/*   /* Restore MD image side to desktop absolute positioning */\n/* .md-image-side { */\n/*   position: absolute; */\n/*   /* right: -450px; */\n/*   margin-left: -50vh; */\n/*   top: -100px; */\n/*   height: 100vh; */\n/*   width: 100vh; */\n/*   display: flex; */\n/*   justify-content: flex-end; */\n/*   flex-direction: column; */\n/* } */\n/* .md-image-side img { */\n/*   position: absolute; */\n/*   /* right: 0; */\n/*   max-width: 100%; */\n/*   height: auto; */\n/*   z-index: 7; */\n\n/*    }  */\n/* } */\n/**/\n/*Mid-width desktop: pull image in proportionally so it doesn't crowd the text*/\n@media (min-width: 769px) and (max-width: 1200px) {\n  /*   .md-image-side { */\n  /*     top: calc(- (-450px + (1200px - 100vw) * -0.4)); */\n  /*     width: 80vh; */\n  /*     /* margin-bottom: -40vh; */\n  .md-message-top {\n    height: auto;\n    min-height: unset;\n    padding: 8vh 0 10vh 0;\n  }\n  .md-content-wrapper {\n    flex-direction: column;\n    width: 88%;\n    text-align: left;\n    gap: 24px;\n    position: static;\n  }\n  .md-text-side h2 {\n    font-size: clamp(28px, 7vw, 42px);\n  }\n  .md-image-side {\n    position: relative;\n    right: auto;\n    top: auto;\n    width: 100%;\n    height: auto;\n    justify-content: center;\n    margin-top: 0;\n    margin-bottom: -8vh;\n    display: flex;\n  }\n  .md-image-side img {\n    position: static;\n    width: 100%;\n    max-width: 700px;\n    height: auto;\n  }\n}\n/* } */\n\n.map-image-wrapper {\n  flex: 1;\n}\n\n.map-image-wrapper img {\n  width: 100%;\n  height: auto;\n}\n\n.map-info {\n  flex: 1;\n}\n\n.map-info h3 {\n  font-size: 45px;\n  font-weight: 800;\n  margin-bottom: 20px;\n  line-height: 1.1;\n}\n\n.map-info p {\n  font-size: 18px;\n  opacity: 0.9;\n  margin-bottom: 40px;\n}\n\n.hub-locations-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  align-items: center;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.hub-location {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--yellow);\n}\n\n.location-dot-wrap {\n  display: flex;\n  padding: 5px;\n  border-radius: 50%;\n  border: 1px solid var(--yellow);\n}\n\n.location-dot {\n  width: 15px;\n  height: 15px;\n  min-width: 15px;\n  background-color: var(--yellow);\n  border-radius: 50%;\n  flex-shrink: 0;\n  padding: 5px;\n}\n\n/* FOOTER CTA SECTION */\n#footer-cta {\n  background-color: var(--black);\n  padding: 15vh 0 5vh 0;\n  color: var(--white);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.footer-container {\n  width: 80%;\n  max-width: 1200px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10vh;\n}\n\n.footer-content-left {\n  flex: 1.5;\n  text-align: left;\n}\n\n.footer-content-left h2 {\n  font-size: 35px;\n  font-weight: 800;\n  line-height: 1.3;\n  margin-bottom: 30px;\n}\n\n.footer-content-left p {\n  font-size: 18px;\n  line-height: 1.6;\n  margin-bottom: 40px;\n  opacity: 0.9;\n}\n\n.download-btn {\n  background-color: var(--red);\n  color: var(--white);\n  border: none;\n  padding: 18px 35px;\n  font-size: 18px;\n  font-weight: 700;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.download-btn:hover {\n  transform: scale(1.05);\n}\n\n.footer-content-right {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.footer-visual {\n  width: 120%;\n  max-width: 600px;\n  height: auto;\n  transform: translateX(10%);\n}\n\n.footer-bottom {\n  width: 80%;\n  max-width: 1200px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  padding-top: 40px;\n  font-size: 14px;\n  opacity: 0.7;\n  text-align: left;\n}\n\n/* =============================================\n   MOBILE RESPONSIVE — max-width: 768px\n   ============================================= */\n@media (max-width: 768px) {\n  /* --- HERO --- */\n  .hero-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n  }\n  .hero-header img {\n    height: 40px;\n  }\n  .hero-header button {\n    width: auto;\n    height: auto;\n    padding: 10px 16px;\n    font-size: 13px;\n    white-space: nowrap;\n  }\n  .hero-body {\n    width: 90%;\n    padding: 6vh 16px;\n  }\n  .hero-body p {\n    font-size: clamp(14px, 4vw, 20px);\n    margin: 12px 0;\n  }\n\n  /* --- INNOVATION --- */\n  .innovation-section {\n    flex-direction: column;\n    width: 90%;\n    padding: 8vh 0 6vh 0;\n    gap: 24px;\n  }\n  .left-panel,\n  #innovation-section-ellipse {\n    display: none;\n  }\n  .right-panel h2 {\n    font-size: clamp(22px, 5vw, 32px);\n    padding-bottom: 2vh;\n  }\n  .carousel-card {\n    margin-top: 4vh;\n    height: auto;\n    min-height: 120px;\n  }\n  .carousel-item {\n    width: 110%;\n    right: -15%;\n    padding: 12px 16px;\n    height: auto;\n  }\n  .carousel-item p {\n    font-size: 12px;\n  }\n\n  /* --- STATS --- */\n  /* On mobile, hide the innovation transition elements that create negative-margin overlap */\n  .innovation-transition {\n    display: none;\n  }\n  #innovation-section-ellipse {\n    display: none;\n  }\n  #stats-section {\n    overflow-x: hidden;\n    margin-top: 0;\n    padding-top: 8vh;\n    padding-bottom: 20vh; /* extra room so indicators clear scholarship top ellipse */\n  }\n  #stats-section h2 {\n    font-size: clamp(28px, 8vw, 48px);\n    margin-bottom: 4vh;\n    padding: 0 20px;\n  }\n  .stats-globe-ring {\n    display: none;\n  }\n  .stats-display {\n    min-height: auto;\n    padding: 10px 0;\n  }\n  .stats-track {\n    height: 420px;\n  }\n  .stat-card {\n    width: 240px;\n  }\n  .stat-card.active .stat-circle {\n    width: 260px;\n    height: 260px;\n  }\n  .stat-card.prev .stat-circle,\n  .stat-card.next .stat-circle,\n  .stat-card.back .stat-circle {\n    width: 180px;\n    height: 180px;\n  }\n  .stat-card.prev {\n    transform: translateX(-140px) translateZ(-100px) scale(0.6);\n  }\n  .stat-card.next {\n    transform: translateX(140px) translateZ(-100px) scale(0.6);\n  }\n  .stat-card.back {\n    display: none;\n  }\n  .stat-card.active .stat-count {\n    font-size: 44px;\n  }\n  .stat-card:not(.active) .stat-count {\n    font-size: 26px;\n  }\n  .stat-card.active .stat-label {\n    font-size: 14px;\n  }\n  .stat-card:not(.active) .stat-label {\n    font-size: 11px;\n  }\n  .stat-description {\n    font-size: 13px;\n    max-width: 240px;\n    padding: 0 8px;\n  }\n\n  /* --- SCHOLARSHIP --- */\n  /* #scholarship-section { */\n  /*   /* padding: 12vh 0 8vh 0; */\n  */\n  /* } */\n  .scholarship-carousel-container {\n    width: 88%;\n  }\n  .scholarship-card {\n    flex-direction: column;\n    text-align: center;\n    gap: 30px;\n  }\n  .scholarship-content-left {\n    order: 2;\n    text-align: center;\n  }\n  .scholarship-content-right {\n    order: 1;\n  }\n  .scholarship-content-left h3 {\n    font-size: clamp(22px, 5vw, 32px);\n  }\n  .description-text {\n    font-size: 15px;\n    max-width: 100%;\n  }\n  .scholarship-nav-indicators {\n    justify-content: center;\n  }\n  .image-circle-container {\n    width: 240px;\n    height: 240px;\n    border-width: 7px;\n  }\n\n  /* --- MOMENTS / TIMELINE --- */\n  #moments-section {\n    padding: 16vh 0 6vh 0; /* extra top clears scholarship bottom ellipse */\n  }\n  .moments-intro {\n    font-size: 15px;\n    padding: 0 8px;\n  }\n  .timeline-container {\n    width: 90%;\n    padding: 30px 0;\n  }\n  /* Move line to left edge on mobile */\n  .timeline-line {\n    left: 12px;\n    top: 30px;\n    bottom: 50vh;\n    transform: none;\n    height: 65%;\n  }\n  /* All items go full-width, aligned to the left line */\n  .timeline-item.right,\n  .timeline-item.left,\n  .timeline-item.center {\n    width: 100%;\n    left: 0;\n    padding-left: 44px;\n    padding-right: 0;\n    text-align: left;\n    margin-top: 0;\n    margin-bottom: 40px;\n  }\n  .timeline-dot.green {\n    background-color: var(--green);\n    margin-top: -10px;\n  }\n  /* All dots sit on the left line */\n  .timeline-item.right .timeline-dot,\n  .timeline-item.left .timeline-dot {\n    left: 0px;\n    right: auto;\n  }\n  /* Large center dot: align to left line (dot is 40px wide, offset by half = -8px from item's left:0) */\n  .timeline-item.center .timeline-dot {\n    left: -8px;\n    transform: none;\n    right: auto;\n  }\n  /* Tags left-aligned for all items on mobile */\n  .timeline-item.left .timeline-tag,\n  .timeline-item.center .timeline-tag {\n    align-self: flex-start;\n  }\n  .timeline-content h4 {\n    font-size: 18px;\n  }\n  .timeline-content p {\n    font-size: 13px;\n    margin-bottom: 2vh;\n  }\n\n  .map-transition {\n    margin-top: -40px;\n    height: 160px;\n  }\n  .md-message-top {\n    height: auto;\n    min-height: unset;\n    padding: 8vh 0 10vh 0;\n  }\n  .md-content-wrapper {\n    flex-direction: column;\n    width: 88%;\n    text-align: left;\n    gap: 24px;\n    position: static;\n  }\n  .md-text-side h2 {\n    font-size: clamp(28px, 7vw, 42px);\n  }\n  /* Stack image naturally below text */\n  .md-image-side {\n    position: relative;\n    right: auto;\n    top: auto;\n    width: 100%;\n    height: auto;\n    justify-content: center;\n    margin-top: 0;\n    margin-bottom: -8vh;\n    display: flex;\n  }\n  .md-image-side img {\n    position: static;\n    width: 70%;\n    max-width: 300px;\n    height: auto;\n  }\n  /* Scrollbar text area */\n  .md-custom-scrollbar-area {\n    max-width: 100%;\n    height: 160px;\n  }\n  .md-text-content p {\n    font-size: 15px;\n  }\n\n  /* --- IMPACT BADGE --- */\n  .impact-multiplier-badge {\n    width: 88%;\n    padding: 16px 20px;\n    gap: 16px;\n    flex-wrap: wrap;\n    justify-content: center;\n    text-align: center;\n    top: 40px;\n  }\n  .multiplier-number {\n    font-size: clamp(36px, 10vw, 60px);\n  }\n  .multiplier-text {\n    font-size: 14px;\n    padding: 12px 18px;\n  }\n\n  /* --- MAP SECTION --- */\n  .md-message-bottom-map {\n    margin-top: 10vh;\n    padding-top: 100px;\n    padding-bottom: 8vh;\n  }\n  .map-container {\n    flex-direction: column-reverse;\n    width: 88%;\n    gap: 30px;\n  }\n  .map-info h3 {\n    font-size: clamp(26px, 6vw, 38px);\n  }\n  /* .map-info p { */\n  /*   font-size: 15px; */\n  /* } */\n  /* .hub-locations-grid { */\n  /*   font-size: 16px; */\n  /*   gap: 14px; */\n  /*   padding: 0; */\n  /* } */\n  /* .location-dot { */\n  /*   width: 11px; */\n  /*   height: 11px; */\n  /* } */\n\n  /* --- FOOTER --- */\n  #footer-cta {\n    padding: 10vh 0 5vh 0;\n  }\n  .footer-container {\n    flex-direction: column;\n    text-align: center;\n    gap: 30px;\n    margin-bottom: 6vh;\n  }\n  .footer-content-left {\n    text-align: center;\n  }\n  .footer-content-left h2 {\n    font-size: clamp(22px, 6vw, 32px);\n  }\n  .footer-content-left p {\n    font-size: 15px;\n  }\n  .footer-content-right {\n    display: none;\n  }\n  .download-btn {\n    font-size: 15px;\n    padding: 14px 28px;\n    width: 100%;\n    max-width: 320px;\n  }\n  .footer-bottom {\n    text-align: center;\n    font-size: 12px;\n  }\n}\n\n/* =============================================\n   EXTRA SMALL — max-width: 480px\n   ============================================= */\n@media (max-width: 480px) {\n  .hero-header button {\n    padding: 8px 12px;\n    font-size: 11px;\n  }\n  .hero-header img {\n    height: 32px;\n  }\n  .stats-track {\n    height: 380px;\n  }\n  .stat-card.active .stat-circle {\n    width: 220px;\n    height: 220px;\n  }\n  .stat-card.prev .stat-circle,\n  .stat-card.next .stat-circle {\n    width: 150px;\n    height: 150px;\n  }\n  .stat-card.prev {\n    transform: translateX(-110px) translateZ(-100px) scale(0.55);\n  }\n  .stat-card.next {\n    transform: translateX(110px) translateZ(-100px) scale(0.55);\n  }\n  .stat-card.active .stat-count {\n    font-size: 36px;\n  }\n  .image-circle-container {\n    width: 200px;\n    height: 200px;\n  }\n  .impact-multiplier-badge {\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
